const camelcaseKeysDeep = require('camelcase-keys-deep');

export class Gender {
  id: string;
  name: string;

  constructor(recordInfo: any) {
    recordInfo = camelcaseKeysDeep(recordInfo);

    this.id = recordInfo.id;
    this.name = recordInfo.name;
  }
}



// WEBPACK FOOTER //
// ./src/app/genders/gender.ts